package kz.dentalcrm.app.screens.quick_replies.list.mvi

import kz.dentalcrm.app.core.base.ViewSideEffect
import kz.dentalcrm.app.data.network.response_model.quick_replies.QuickReply

sealed interface QuickRepliesViewSideEffect : ViewSideEffect {
    data class ShowEditQuickReply(val quickReply: QuickReply) : QuickRepliesViewSideEffect
}
